import { createContext, useContext } from 'react'
import { ImageType } from 'store/features/imageView'

export const ActiveImageTypeContext = createContext<ImageType>('bust')

export const useActiveImageType = () => useContext(ActiveImageTypeContext)
